import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { GenericWidgetComponent } from "../generic-widget/generic-widget.component";
import { SessionService } from "src/app/session.service";
import { DashboardService } from "../../dashboard.service";
import { UiService } from "src/app/ui/ui.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-delivered-content-widget",
  templateUrl: "./delivered-content-widget.component.html",
  styleUrls: ["./delivered-content-widget.component.scss"],
})
export class DeliveredContentWidgetComponent extends GenericWidgetComponent {
  private signals: any;
  contentTypes = [
    {
      name: "Mobile Push",
      type: "push",
      icon: "assets/svg/push-content.svg",
      svgStyle: {
        "width.px": "17",
        "height.px": "17",
      },
    },
  ];
  selectedContentType = "push";
  categories: any;
  filteredSignals: any;
  constructor(
    private DashboardService: DashboardService,
    private SessionService: SessionService,
    private ChangeDetectorRef: ChangeDetectorRef,
    private uiService: UiService,
  ) {
    super();
  }

  get accountID() {
    return this.SessionService.currentAccountValue!.accountID;
  }

  get leftScrollDisabled() {
    const signalsElement = document.getElementById("signals");
    if (signalsElement) {
      return signalsElement.scrollLeft === 0;
    }
    return true;
  }

  get rightScrollDisabled() {
    const signalsElement = document.getElementById("signals");
    if (signalsElement) {
      return (
        signalsElement.scrollLeft + signalsElement.offsetWidth ===
        signalsElement.scrollWidth
      );
    }
    return true;
  }

  get accountAppID() {
    return this.SessionService.currentAppValue!.id;
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.initData();
    this.filterForm.valueChanges
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(() => {
        if (
          this.filterForm.valid &&
          this.filterForm.controls.startDate.value <
            this.filterForm.controls.endDate.value
        ) {
          this.initData();
        }
      });
  }

  initData() {
    this.filterForm.controls.endDate.value.setHours(23, 59, 59);

    this.elementLoader
      .waitForEvent(
        this.DashboardService.getDeliveredContent(
          this.accountID,
          this.accountAppID,
          this.filterForm.controls.startDate.value,
          this.filterForm.controls.endDate.value,
        ),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((res: any) => {
        this.signals = res.map((signal: any) => {
          const oldIconMap = this.uiService.oldFAIconsMap.find(
            (icon) => icon.name === signal.category_icon,
          );
          //Some icons are old Fontawesome icons, this is used to update them
          let iconArr;

          if (oldIconMap) {
            signal.category_icon = oldIconMap.newIconString;
          }
          iconArr = signal.category_icon!.split(" ");

          return {
            ...signal,
            sent_on_text: this.getLastSentOnText(signal.last_sent_on),
            iconArr,
          };
        });

        this.categories = [];
        for (let signal of this.signals) {
          const category = this.categories.find(
            (category: any) => category.id === signal.category_id,
          );

          if (category) {
            category.count = category.count + 1;
          } else {
            const categoryObj = {
              id: signal.category_id,
              name: signal.category_name,
              icon: signal.category_icon,
              iconArr: signal.iconArr,
              color: signal.category_color,
              selected: true,
              count: 1,
            };
            this.categories.push(categoryObj);
          }
        }

        this.categories.sort((a: any, b: any) => b.count - a.count);

        this.initFilteredSignals();
      });
  }

  getLastSentOnText(dateString: string) {
    const date = new Date(dateString);
    const currentDate = new Date();
    const weekAgoDate = new Date();
    weekAgoDate.setDate(weekAgoDate.getDate() - 7);

    //If current date return time
    if (
      date.getDate() === currentDate.getDate() &&
      date.getMonth() === currentDate.getMonth() &&
      date.getFullYear() === currentDate.getFullYear()
    ) {
      let hr = date.getHours();
      let min: number | string = date.getMinutes();
      if (min < 10) {
        min = "0" + min;
      }
      let ampm = "am";
      if (hr === 0) {
        hr = 12;
      } else if (hr >= 12) {
        if (hr !== 12) {
          hr -= 12;
        }
        ampm = "pm";
      }

      return `${hr}:${min}${ampm}`;
    }
    //If date is within a week from today return week day
    else if (currentDate >= date && date >= weekAgoDate) {
      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      return days[date.getDay()];
    } else {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      return `${months[date.getMonth()]} ${date.getDate()}`;
    }
  }

  moveLeft() {
    const signalsElement = document.getElementById("signals");
    if (signalsElement) {
      signalsElement.scrollTo({
        left: signalsElement.scrollLeft - signalsElement.offsetWidth + 100,
        behavior: "smooth",
      });
      setTimeout(() => {
        this.ChangeDetectorRef.detectChanges();
      }, 300);
    }
  }

  moveRight() {
    const signalsElement = document.getElementById("signals");
    if (signalsElement) {
      signalsElement.scrollTo({
        left: signalsElement.scrollLeft + signalsElement.offsetWidth - 100,
        behavior: "smooth",
      });
      setTimeout(() => {
        this.ChangeDetectorRef.detectChanges();
      }, 300);
    }
  }

  toggleCategory(category: any) {
    category.selected = !category.selected;
    this.initFilteredSignals();
  }

  initFilteredSignals() {
    this.filteredSignals = this.signals.filter((signal: any) => {
      return this.categories.find(
        (category: any) => category.id === signal.category_id,
      )?.selected;
    });
  }
}
